<template>
  <!--Contact Section-->
  <section class="contact-section wow fadeInUp animated">
    <div class="auto-container">
      <div class="sec-title with-separator centered">
        <h2>Contact Us</h2>
        <!-- <div class="separator">
          <span class="cir c-1"></span><span class="cir c-2"></span><span class="cir c-3"></span>
        </div> -->
      </div>
      <div class="row clearfix">
        <div class="left-col col-lg-6 col-md-12 col-sm-12 wow fadeInUp animated">
          <div class="inner-box">
            <div class="/image/ clearfix">
              <figure class="image"><img :src="data.document" alt="" /></figure>
              <!--              <figure class="image"><img src="/images/banner/16 中曼钻机照片4.webp" alt="" /></figure>-->
            </div>
          </div>
        </div>
        <div
          class="right-col col-lg-6 col-md-12 col-sm-12 wow bounceInRight animated"
          data-wow-delay="0.5s"
          style="visibility: visible; animation-delay: 0.5s; animation-name: bounceInRight"
        >
          <div class="contact-info-box">
            <div class="content_main" v-html="data.contents"></div>
            <!-- <div>Please kindly contact the following email address:</div>
						<div>gm.office@petro-ak.com</div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api/index.js'
export default {
  data() {
    return {
      URLTYPE: this.$store.screen.URLTYPE,
      loading: false,
      Page: {
        total: 10,
        currentPage: 1,
        pageSize: 10,
        orders: [],
      },
      data: [],
    }
  },
  mounted() {
    // this.init()
  },
  methods: {
    init(data) {
      this.loading = true
      if (data) {
        this.data = data
        this.loading = false
      } else {
        api
          .webList({
            pageNo: this.Page.currentPage,
            pageSize: this.Page.pageSize,
            isPublished: '1', //是发布的
            columnName: 'Contact US',
          })
          .then((res) => {
            this.data = res.page.list[0]
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.left-col,
.right-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.contact-info-box {
  font-size: 20px;
  font-weight: 700;
  color: #222222;
  font-family: 'Manjari', sans-serif;
  & > div {
    margin-bottom: 15px;
  }
}
</style>
